import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Tue May 06 2025 19:20:30 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type AlternateAudioFilesQueryVariables = Types.Exact<{
  hashedId: Types.Scalars['HashedId']['input'];
}>;


export type AlternateAudioFilesQuery = { __typename?: 'Query', media?: { __typename?: 'Audio', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Avatar', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Document', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Image', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'LiveSharedVideo', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'LiveStream', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Logo', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'MicrosoftOfficeDocument', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'PdfDocument', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Swf', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'UnknownMedia', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | { __typename?: 'Video', id: string, duration?: number | null | undefined, alternateAudioFiles?: Array<{ __typename?: 'AlternateAudioFile', id: string, type?: string | null | undefined, ordered: boolean, threeplayAudioDescription?: { __typename?: 'ThreeplayAudioDescription', id: string, enabled: boolean } | null | undefined, mediaFileDetails: { __typename?: 'MediaFileDetails', id: string, language?: string | null | undefined, audioDescription?: boolean | null | undefined, languageMetadata: { __typename?: 'LanguageMetadata', name: string, nativeName: string } } }> | null | undefined } | null | undefined };

export type DownloadAlternateAudioFileMutationVariables = Types.Exact<{
  input: Types.DownloadAlternateAudioFileInput;
}>;


export type DownloadAlternateAudioFileMutation = { __typename?: 'Mutation', downloadAlternateAudioFile?: { __typename?: 'DownloadAlternateAudioFilePayload', downloadUrl: string } | null | undefined };

export type CreateAlternateAudioFileMutationVariables = Types.Exact<{
  input: Types.CreateAlternateAudioFileInput;
}>;


export type CreateAlternateAudioFileMutation = { __typename?: 'Mutation', createAlternateAudioFile?: { __typename?: 'CreateAlternateAudioFilePayload', success: boolean } | null | undefined };

export type UpdateAlternateAudioFileMutationVariables = Types.Exact<{
  input: Types.UpdateAlternateAudioFileInput;
}>;


export type UpdateAlternateAudioFileMutation = { __typename?: 'Mutation', updateAlternateAudioFile?: { __typename?: 'UpdateAlternateAudioFilePayload', success: boolean } | null | undefined };

export type DeleteAlternateAudioFileMutationVariables = Types.Exact<{
  input: Types.DeleteAlternateAudioFileInput;
}>;


export type DeleteAlternateAudioFileMutation = { __typename?: 'Mutation', deleteAlternateAudioFile?: { __typename?: 'DeleteAlternateAudioFilePayload', success: boolean } | null | undefined };

export type DeleteAlternateAudioFileDerivativeMutationVariables = Types.Exact<{
  input: Types.DeleteAlternateAudioFileDerivativeInput;
}>;


export type DeleteAlternateAudioFileDerivativeMutation = { __typename?: 'Mutation', deleteAlternateAudioFileDerivative?: { __typename?: 'DeleteAlternateAudioFileDerivativePayload', success: boolean } | null | undefined };

export type RestoreAlternateAudioFileDerivativeMutationVariables = Types.Exact<{
  input: Types.RestoreAlternateAudioFileDerivativeInput;
}>;


export type RestoreAlternateAudioFileDerivativeMutation = { __typename?: 'Mutation', restoreAlternateAudioFileDerivative?: { __typename?: 'RestoreAlternateAudioFileDerivativePayload', success: boolean } | null | undefined };


export const AlternateAudioFilesDocument = gql`
    query AlternateAudioFiles($hashedId: HashedId!) {
  media(hashedId: $hashedId) {
    id
    duration
    alternateAudioFiles {
      id
      type
      ordered
      threeplayAudioDescription {
        id
        enabled
      }
      mediaFileDetails {
        id
        language
        audioDescription
        languageMetadata {
          name
          nativeName
        }
      }
    }
  }
}
    `;

/**
 * __useAlternateAudioFilesQuery__
 *
 * To run a query within a React component, call `useAlternateAudioFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlternateAudioFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlternateAudioFilesQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useAlternateAudioFilesQuery(baseOptions: Apollo.QueryHookOptions<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables> & ({ variables: AlternateAudioFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>(AlternateAudioFilesDocument, options);
      }
export function useAlternateAudioFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>(AlternateAudioFilesDocument, options);
        }
export function useAlternateAudioFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>(AlternateAudioFilesDocument, options);
        }
export type AlternateAudioFilesQueryHookResult = ReturnType<typeof useAlternateAudioFilesQuery>;
export type AlternateAudioFilesLazyQueryHookResult = ReturnType<typeof useAlternateAudioFilesLazyQuery>;
export type AlternateAudioFilesSuspenseQueryHookResult = ReturnType<typeof useAlternateAudioFilesSuspenseQuery>;
export type AlternateAudioFilesQueryResult = Apollo.QueryResult<AlternateAudioFilesQuery, AlternateAudioFilesQueryVariables>;
export const DownloadAlternateAudioFileDocument = gql`
    mutation DownloadAlternateAudioFile($input: DownloadAlternateAudioFileInput!) {
  downloadAlternateAudioFile(input: $input) {
    downloadUrl
  }
}
    `;
export type DownloadAlternateAudioFileMutationFn = Apollo.MutationFunction<DownloadAlternateAudioFileMutation, DownloadAlternateAudioFileMutationVariables>;

/**
 * __useDownloadAlternateAudioFileMutation__
 *
 * To run a mutation, you first call `useDownloadAlternateAudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAlternateAudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAlternateAudioFileMutation, { data, loading, error }] = useDownloadAlternateAudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAlternateAudioFileMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAlternateAudioFileMutation, DownloadAlternateAudioFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAlternateAudioFileMutation, DownloadAlternateAudioFileMutationVariables>(DownloadAlternateAudioFileDocument, options);
      }
export type DownloadAlternateAudioFileMutationHookResult = ReturnType<typeof useDownloadAlternateAudioFileMutation>;
export type DownloadAlternateAudioFileMutationResult = Apollo.MutationResult<DownloadAlternateAudioFileMutation>;
export type DownloadAlternateAudioFileMutationOptions = Apollo.BaseMutationOptions<DownloadAlternateAudioFileMutation, DownloadAlternateAudioFileMutationVariables>;
export const CreateAlternateAudioFileDocument = gql`
    mutation CreateAlternateAudioFile($input: CreateAlternateAudioFileInput!) {
  createAlternateAudioFile(input: $input) {
    success
  }
}
    `;
export type CreateAlternateAudioFileMutationFn = Apollo.MutationFunction<CreateAlternateAudioFileMutation, CreateAlternateAudioFileMutationVariables>;

/**
 * __useCreateAlternateAudioFileMutation__
 *
 * To run a mutation, you first call `useCreateAlternateAudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlternateAudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlternateAudioFileMutation, { data, loading, error }] = useCreateAlternateAudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlternateAudioFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlternateAudioFileMutation, CreateAlternateAudioFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlternateAudioFileMutation, CreateAlternateAudioFileMutationVariables>(CreateAlternateAudioFileDocument, options);
      }
export type CreateAlternateAudioFileMutationHookResult = ReturnType<typeof useCreateAlternateAudioFileMutation>;
export type CreateAlternateAudioFileMutationResult = Apollo.MutationResult<CreateAlternateAudioFileMutation>;
export type CreateAlternateAudioFileMutationOptions = Apollo.BaseMutationOptions<CreateAlternateAudioFileMutation, CreateAlternateAudioFileMutationVariables>;
export const UpdateAlternateAudioFileDocument = gql`
    mutation UpdateAlternateAudioFile($input: UpdateAlternateAudioFileInput!) {
  updateAlternateAudioFile(input: $input) {
    success
  }
}
    `;
export type UpdateAlternateAudioFileMutationFn = Apollo.MutationFunction<UpdateAlternateAudioFileMutation, UpdateAlternateAudioFileMutationVariables>;

/**
 * __useUpdateAlternateAudioFileMutation__
 *
 * To run a mutation, you first call `useUpdateAlternateAudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlternateAudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlternateAudioFileMutation, { data, loading, error }] = useUpdateAlternateAudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlternateAudioFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlternateAudioFileMutation, UpdateAlternateAudioFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlternateAudioFileMutation, UpdateAlternateAudioFileMutationVariables>(UpdateAlternateAudioFileDocument, options);
      }
export type UpdateAlternateAudioFileMutationHookResult = ReturnType<typeof useUpdateAlternateAudioFileMutation>;
export type UpdateAlternateAudioFileMutationResult = Apollo.MutationResult<UpdateAlternateAudioFileMutation>;
export type UpdateAlternateAudioFileMutationOptions = Apollo.BaseMutationOptions<UpdateAlternateAudioFileMutation, UpdateAlternateAudioFileMutationVariables>;
export const DeleteAlternateAudioFileDocument = gql`
    mutation DeleteAlternateAudioFile($input: DeleteAlternateAudioFileInput!) {
  deleteAlternateAudioFile(input: $input) {
    success
  }
}
    `;
export type DeleteAlternateAudioFileMutationFn = Apollo.MutationFunction<DeleteAlternateAudioFileMutation, DeleteAlternateAudioFileMutationVariables>;

/**
 * __useDeleteAlternateAudioFileMutation__
 *
 * To run a mutation, you first call `useDeleteAlternateAudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternateAudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternateAudioFileMutation, { data, loading, error }] = useDeleteAlternateAudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAlternateAudioFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlternateAudioFileMutation, DeleteAlternateAudioFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlternateAudioFileMutation, DeleteAlternateAudioFileMutationVariables>(DeleteAlternateAudioFileDocument, options);
      }
export type DeleteAlternateAudioFileMutationHookResult = ReturnType<typeof useDeleteAlternateAudioFileMutation>;
export type DeleteAlternateAudioFileMutationResult = Apollo.MutationResult<DeleteAlternateAudioFileMutation>;
export type DeleteAlternateAudioFileMutationOptions = Apollo.BaseMutationOptions<DeleteAlternateAudioFileMutation, DeleteAlternateAudioFileMutationVariables>;
export const DeleteAlternateAudioFileDerivativeDocument = gql`
    mutation DeleteAlternateAudioFileDerivative($input: DeleteAlternateAudioFileDerivativeInput!) {
  deleteAlternateAudioFileDerivative(input: $input) {
    success
  }
}
    `;
export type DeleteAlternateAudioFileDerivativeMutationFn = Apollo.MutationFunction<DeleteAlternateAudioFileDerivativeMutation, DeleteAlternateAudioFileDerivativeMutationVariables>;

/**
 * __useDeleteAlternateAudioFileDerivativeMutation__
 *
 * To run a mutation, you first call `useDeleteAlternateAudioFileDerivativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternateAudioFileDerivativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternateAudioFileDerivativeMutation, { data, loading, error }] = useDeleteAlternateAudioFileDerivativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAlternateAudioFileDerivativeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlternateAudioFileDerivativeMutation, DeleteAlternateAudioFileDerivativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlternateAudioFileDerivativeMutation, DeleteAlternateAudioFileDerivativeMutationVariables>(DeleteAlternateAudioFileDerivativeDocument, options);
      }
export type DeleteAlternateAudioFileDerivativeMutationHookResult = ReturnType<typeof useDeleteAlternateAudioFileDerivativeMutation>;
export type DeleteAlternateAudioFileDerivativeMutationResult = Apollo.MutationResult<DeleteAlternateAudioFileDerivativeMutation>;
export type DeleteAlternateAudioFileDerivativeMutationOptions = Apollo.BaseMutationOptions<DeleteAlternateAudioFileDerivativeMutation, DeleteAlternateAudioFileDerivativeMutationVariables>;
export const RestoreAlternateAudioFileDerivativeDocument = gql`
    mutation RestoreAlternateAudioFileDerivative($input: RestoreAlternateAudioFileDerivativeInput!) {
  restoreAlternateAudioFileDerivative(input: $input) {
    success
  }
}
    `;
export type RestoreAlternateAudioFileDerivativeMutationFn = Apollo.MutationFunction<RestoreAlternateAudioFileDerivativeMutation, RestoreAlternateAudioFileDerivativeMutationVariables>;

/**
 * __useRestoreAlternateAudioFileDerivativeMutation__
 *
 * To run a mutation, you first call `useRestoreAlternateAudioFileDerivativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAlternateAudioFileDerivativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAlternateAudioFileDerivativeMutation, { data, loading, error }] = useRestoreAlternateAudioFileDerivativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreAlternateAudioFileDerivativeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreAlternateAudioFileDerivativeMutation, RestoreAlternateAudioFileDerivativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreAlternateAudioFileDerivativeMutation, RestoreAlternateAudioFileDerivativeMutationVariables>(RestoreAlternateAudioFileDerivativeDocument, options);
      }
export type RestoreAlternateAudioFileDerivativeMutationHookResult = ReturnType<typeof useRestoreAlternateAudioFileDerivativeMutation>;
export type RestoreAlternateAudioFileDerivativeMutationResult = Apollo.MutationResult<RestoreAlternateAudioFileDerivativeMutation>;
export type RestoreAlternateAudioFileDerivativeMutationOptions = Apollo.BaseMutationOptions<RestoreAlternateAudioFileDerivativeMutation, RestoreAlternateAudioFileDerivativeMutationVariables>;